import React, { useState } from 'react'
import { Alert, Button, Card, Col, Form, InputGroup, Row, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import efectivo from '../../assets/images/efectivo.png'
import tarjeta from '../../assets/images/tarjeta.png'
import { setDiscountApplied, setSlide } from '../../services/registerSlice'
import { useValidateDiscountCodeMutation } from '../../services/catalogsApi'


export const SlideSeven = () => {
  const dispatch = useDispatch()
  const { packageSelected, packageTuristicSelected, discountApplied } = useSelector(state => state.registerData)

  const [codeInput, setCodeInput] = useState('')
  const [discountError, setDiscountError] = useState(null)
  const [validateDiscount, { isLoading: isValidating }] = useValidateDiscountCodeMutation()

  const totalBase = (packageSelected?.amount ?? 0) + (packageTuristicSelected ? packageTuristicSelected.amount : 0)
  const totalFinal = discountApplied ? Math.max(0, totalBase - discountApplied.amount) : totalBase

  const handleOption = (opt) => {
    if (opt === 'PT') {
      dispatch(setSlide({ slide: 8 }))
    } else {
      dispatch(setSlide({ slide: 9 }))
    }
  }

  const handleApplyCode = async () => {
    if (!codeInput.trim()) return
    setDiscountError(null)
    try {
      const result = await validateDiscount({
        code: codeInput.trim().toUpperCase(),
        currency: packageSelected?.currency,
      }).unwrap()
      dispatch(setDiscountApplied({ data: result }))
      setCodeInput('')
    } catch (err) {
      const msg = err?.data?.detail || 'Código inválido o no aplica para tu moneda.'
      setDiscountError(msg)
      dispatch(setDiscountApplied({ data: null }))
    }
  }

  const handleRemoveCode = () => {
    dispatch(setDiscountApplied({ data: null }))
    setDiscountError(null)
    setCodeInput('')
  }

  return (
    <>
      <Row className='d-flex justify-content-center mt-3'>
        <Col md={6}>
          <h1 className='fw-normal h6'>
            <span className='border-bottom border-primary border-2 pb-1'>Forma de Pago</span>
          </h1>
        </Col>
      </Row>

      {/* Sección código de descuento */}
      <Row className='d-flex justify-content-center mt-3'>
        <Col md={6}>
          <div className='border rounded p-3 mb-3 bg-light'>
            <p className='mb-2 fw-semibold small text-muted'>¿Tienes un código de descuento?</p>

            {discountApplied ? (
              <Alert variant='success' className='d-flex justify-content-between align-items-center py-2 mb-0'>
                <span>
                  <i className='bi bi-tag-fill me-1'></i>
                  <strong>{discountApplied.code}</strong> — descuento de{' '}
                  <strong>{discountApplied.amount.toLocaleString('en-US')} {discountApplied.currency}</strong>
                  {discountApplied.description && (
                    <span className='text-muted ms-1'>({discountApplied.description})</span>
                  )}
                </span>
                <button className='btn btn-sm btn-outline-danger ms-3' onClick={handleRemoveCode}>
                  <i className='bi bi-x-lg'></i>
                </button>
              </Alert>
            ) : (
              <>
                <InputGroup>
                  <Form.Control
                    type='text'
                    placeholder='Ej. DESCUENTO10'
                    value={codeInput}
                    onChange={e => { setCodeInput(e.target.value.toUpperCase()); setDiscountError(null) }}
                    onKeyDown={e => e.key === 'Enter' && handleApplyCode()}
                    style={{ textTransform: 'uppercase' }}
                  />
                  <Button variant='outline-primary' onClick={handleApplyCode} disabled={isValidating || !codeInput.trim()}>
                    {isValidating ? <Spinner size='sm' /> : 'Aplicar'}
                  </Button>
                </InputGroup>
                {discountError && <p className='text-danger small mt-1 mb-0'>{discountError}</p>}
              </>
            )}

            {/* Resumen de totales */}
            <div className='mt-3 pt-2 border-top small'>
              <div className='d-flex justify-content-between text-muted'>
                <span>Subtotal</span>
                <span>{totalBase.toLocaleString('en-US')} {packageSelected?.currency}</span>
              </div>
              {discountApplied && (
                <div className='d-flex justify-content-between text-success'>
                  <span>Descuento ({discountApplied.code})</span>
                  <span>-{discountApplied.amount.toLocaleString('en-US')} {discountApplied.currency}</span>
                </div>
              )}
              <div className='d-flex justify-content-between fw-bold mt-1'>
                <span>Total a pagar</span>
                <span>{totalFinal.toLocaleString('en-US')} {packageSelected?.currency}</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Métodos de pago */}
      <Row className='d-flex justify-content-center mt-2 mb-5'>
        <Col md={3} className='mt-3'>
          <Card className='border-0 mb-5 pb-3 card-custom-style rounded-top-2 btn-cices-full-blue-v2 d-flex justify-content-center'>
            <Card.Img variant="top" src={tarjeta} className='mb-5 pt-5' style={{ width: '35%', alignSelf: 'center' }} />
            <Card.Body className='px-4 pb-4' style={{ marginTop: '15px' }}>
              <div className="d-grid gap-2">
                <Button className='btn-cices-v2 fw-bold' onClick={() => handleOption('PT')}>Tarjeta de credito/debito</Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3} className='mt-3'>
          <Card className='border-0 mb-5 pb-3 card-custom-style rounded-top-2 btn-cices-full-blue-v2 d-flex justify-content-center'>
            <Card.Img variant="top" src={efectivo} className='mb-5 pt-5' style={{ width: '35%', alignSelf: 'center' }} />
            <Card.Body className='px-4 pb-4' style={{ marginTop: '15px' }}>
              <div className="d-grid gap-2">
                <Button className='btn-cices-v2 fw-bold' onClick={() => handleOption('TI')}>Otra forma de pago</Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}
